import { Errors as IconErrors } from '../../picture/objects/errors';
import { Picture } from '../../picture/objects/picture';
import { CircuitCategory } from '../objects/circuitCategory';
import { Column } from '../objects/column';
import { List } from '../objects/list';


export const DELETE_PICTURE = 'CIRCUIT_CATEGORY_DELETE_PICTURE';
export const MOVE_DOWN_COLUMN = 'CIRCUIT_CATEGORY_MOVE_DOWN_COLUMN';
export const MOVE_UP_COLUMN = 'CIRCUIT_CATEGORY_MOVE_UP_COLUMN';
export const RESET_FILTERS = 'CIRCUIT_CATEGORY_RESET_FILTERS';
export const SET_EXPORT_TYPE = 'CIRCUIT_CATEGORY_SET_EXPORT_TYPE';
export const SET_LIMIT = 'CIRCUIT_CATEGORY_SET_LIMIT';
export const SET_LIST = 'CIRCUIT_CATEGORY_SET_LIST';
export const SET_ORDER_BY = 'CIRCUIT_CATEGORY_SET_ORDER_BY';
export const SET_PAGE = 'CIRCUIT_CATEGORY_SET_PAGE';
export const SET_RUNNING = 'CIRCUIT_CATEGORY_SET_RUNNING';
export const SET_SEARCH = 'DESTINATION_SET_SEARCH';
export const TOGGLE_COLUMN = 'ESTINATION_CATEGORY_TOGGLE_COLUMN';
export const TOGGLE_EXPORT = 'CIRCUIT_CATEGORY_TOGGLE_EXPORT';
export const TOGGLE_EXPORT_FULL = 'CIRCUIT_CATEGORY_TOGGLE_EXPORT_FULL';
export const TOGGLE_FILTERS = 'CIRCUIT_CATEGORY_TOGGLE_FILTERS';
export const TOGGLE_REFRESH = 'CIRCUIT_CATEGORY_TOGGLE_REFRESH';
export const TOGGLE_PICTURES_ORDER = 'CIRCUIT_CATEGORY_TOGGLE_PICTURES_ORDER';
export const UPDATE_FILTER_CREATED_DATE_GTE = 'CIRCUIT_CATEGORY_UPDATE_FILTER_CREATED_DATE_GTE';
export const UPDATE_FILTER_CREATED_DATE_LTE = 'CIRCUIT_CATEGORY_UPDATE_FILTER_CREATED_DATE_LTE';
export const UPDATE_FILTER_NAME = 'CIRCUIT_CATEGORY_UPDATE_FILTER_NAME';
export const UPDATE_FILTER_CREATOR = 'CIRCUIT_CATEGORY_UPDATE_FILTER_CREATOR';
export const UPDATE_FILTER_LAST_AUTHOR = 'CIRCUIT_CATEGORY_UPDATE_FILTER_LAST_AUTHOR';
export const UPDATE_FILTER_MODIFIED_DATE_GTE = 'CIRCUIT_CATEGORY_UPDATE_FILTER_MODIFIED_DATE_GTE';
export const UPDATE_FILTER_MODIFIED_DATE_LTE = 'CIRCUIT_CATEGORY_UPDATE_FILTER_MODIFIED_DATE_LTE';
export const UPDATE_FILTER_PERIOD = 'CIRCUIT_CATEGORY_UPDATE_FILTER_PERIOD';
export const UPDATE_FILTER_PERIOD_TYPE = 'CIRCUIT_CATEGORY_UPDATE_FILTER_PERIOD_TYPE';
export const TOGGLE_CANCEL_MODAL = 'CIRCUIT_CATEGORY_TOGGLE_CANCEL_MODAL';
export const TOGGLE_UPLOAD_ICON = 'CIRCUIT_CATEGORY_TOGGLE_UPLOAD_ICON';
export const UPDATE_PICTURE_ORDER = 'CIRCUIT_CATEGORY_UPDATE_PICTURE_ORDER';
export const UPDATE_ICON = 'CIRCUIT_CATEGORY_UPDATE_PICTURE';
export const UPDATE_ICON_PROGRESS = 'CIRCUIT_CATEGORY_UPDATE_ICON_PROGRESS';
export const UPDATE_ICON_STEP = 'CIRCUIT_CATEGORY_UPDATE_ICON_STEP';
export const RESET_ADD_CATEGORY = 'CIRCUIT_CATEGORY_RESET_ADD_CATEGORY';
export const RESET_ICON = 'CIRCUIT_CATEGORY_RESET_ICON';
export const UPDATE_CIRCUIT_CATEGORY_NAME_LOCALE = 'CIRCUIT_CATEGORY_UPDATE_CIRCUIT_CATEGORY_NAME_LOCALE';
export const UPDATE_CIRCUIT_CATEGORY_DESCRIPTION_LOCALE = 'CIRCUIT_CATEGORY_UPDATE_CIRCUIT_CATEGORY_DESCRIPTION_LOCALE';
export const SET_UPLOAD_ICON_VIDEO_INPUT = 'USER_SET_UPLOAD_ICON_VIDEO_INPUT';
export const TOGGLE_CREATE = 'CIRCUIT_CATEGORY_TOGGLE_CREATE';
export const SET_CATEGORY = 'CIRCUIT_CATEGORY_SET_CATEGORY';
export const SET_CATEGORY_DELETE = 'CIRCUIT_CATEGORY_SET_CATEGORY_DELETE';
export const SET_EDIT_STEP = 'CIRCUIT_CATEGORY_SET_EDIT_STEP';
export const SET_ICON_ERRORS = 'CIRCUIT_CATEGORY_SET_ICON_ERRORS';
export const UPDATE_REFERENCE = 'CIRCUIT_CATEGORY_UPDATE_REFERENCE';
export const SET_COLUMNS = 'CIRCUIT_CATEGORY_SET_COLUMNS';
export const RESIZE_COLUMN = 'CIRCUIT_CATEGORY_RESIZE_COLUMN';


interface SetColumnsAction {
    type: typeof SET_COLUMNS,
    payload: Column[]
}

interface ResizeColumnAction {
    type: typeof RESIZE_COLUMN,
    payload: { field_name: string; width: number }
}

interface DeletePictureAction {
    type: typeof DELETE_PICTURE,
    payload: number
}
interface MoveDownColumnAction {
    type: typeof MOVE_DOWN_COLUMN,
    payload: number
}

interface MoveUpColumnAction {
    type: typeof MOVE_UP_COLUMN,
    payload: number
}

interface ResetFiltersAction {
    type: typeof RESET_FILTERS
}

interface SetExportTypeAction {
    type: typeof SET_EXPORT_TYPE,
    payload: 'CSV' | 'PDF'
}

interface SetLimitAction {
    type: typeof SET_LIMIT,
    payload: number
}

interface SetListAction {
    type: typeof SET_LIST,
    payload: List
}

interface SetOrderByAction {
    type: typeof SET_ORDER_BY,
    payload: string
}

interface SetPageAction {
    type: typeof SET_PAGE,
    payload: number
}

interface SetRunningAction {
    type: typeof SET_RUNNING,
    payload: boolean
}

interface SetSearchAction {
    type: typeof SET_SEARCH,
    payload: string
}


interface SetUploadIconVideoInputAction {
    type: typeof SET_UPLOAD_ICON_VIDEO_INPUT,
    payload: boolean
}


interface TogglePicturesOrderAction {
    type: typeof TOGGLE_PICTURES_ORDER,
}

interface ToggleColumnAction {
    type: typeof TOGGLE_COLUMN,
    payload: number
}

interface ToggleExportAction {
    type: typeof TOGGLE_EXPORT,
    payload: boolean
}

interface ToggleExportFullAction {
    type: typeof TOGGLE_EXPORT_FULL
}

interface ToggleFiltersAction {
    type: typeof TOGGLE_FILTERS
}

interface ToggleRefreshAction {
    type: typeof TOGGLE_REFRESH
}

interface UpdateFilterCreatedDateGteAction {
    type: typeof UPDATE_FILTER_CREATED_DATE_GTE,
    payload: Date | null
}

interface UpdateFilterCreatedDateLteAction {
    type: typeof UPDATE_FILTER_CREATED_DATE_LTE,
    payload: Date | null
}

interface UpdateFilterNameAction {
    type: typeof UPDATE_FILTER_NAME,
    payload: string
}

interface UpdateFilterCreatorAction {
    type: typeof UPDATE_FILTER_CREATOR,
    payload: string
}

interface UpdateFilterLastAuthorAction {
    type: typeof UPDATE_FILTER_LAST_AUTHOR,
    payload: string
}

interface UpdateFilterModifiedDateGteAction {
    type: typeof UPDATE_FILTER_MODIFIED_DATE_GTE,
    payload: Date | null
}

interface UpdateFilterModifiedDateLteAction {
    type: typeof UPDATE_FILTER_MODIFIED_DATE_LTE,
    payload: Date | null
}

interface UpdateFilterPeriodAction {
    type: typeof UPDATE_FILTER_PERIOD,
    payload: 'CREATION' | 'MODIFICATION'
}

interface UpdateFilterPeriodTypeAction {
    type: typeof UPDATE_FILTER_PERIOD_TYPE,
    payload: number
}


interface UpdatePictureOrderAction {
    type: typeof UPDATE_PICTURE_ORDER,
    payload: {
        drag_index: number,
        hover_index: number
    }
}

interface ToggleCancelModalAction {
    type: typeof TOGGLE_CANCEL_MODAL
}


interface ToggleUploadIconAction {
    type: typeof TOGGLE_UPLOAD_ICON
}

interface ToggleCreateAction {
    type: typeof TOGGLE_CREATE
}

interface SetCategoryAction {
    type: typeof SET_CATEGORY
    payload: CircuitCategory
}

interface SetCategoryDeleteAction {
    type: typeof SET_CATEGORY_DELETE
    payload: null | false | CircuitCategory
}

interface ResetAddCategoryAction {
    type: typeof RESET_ADD_CATEGORY
}

interface SetEditStepAction {
    type: typeof SET_EDIT_STEP
    payload: string | null
}

interface SetIconErrorsAction {
    type: typeof SET_ICON_ERRORS,
    payload: IconErrors | null
}

interface ResetIcon {
    type: typeof RESET_ICON,
}

interface UpdateCircuitCategoryNameLocaleAction {
    type: typeof UPDATE_CIRCUIT_CATEGORY_NAME_LOCALE,
    payload: {
        value: string,
        id: number,
    }
}

interface UpdateCircuitCategoryDescriptionLocaleAction {
    type: typeof UPDATE_CIRCUIT_CATEGORY_DESCRIPTION_LOCALE,
    payload: {
        value: string,
        id: number,
    }
}

interface UpdateIconAction {
    type: typeof UPDATE_ICON,
    payload: Picture | null
}

interface UpdateIconProgressAction {
    type: typeof UPDATE_ICON_PROGRESS,
    payload: number
}


interface UpdateIconStepAction {
    type: typeof UPDATE_ICON_STEP,
    payload: 1 | 2
}

interface UpdateReference{
    type: typeof UPDATE_REFERENCE,
    payload: string
}

export type CircuitCategoryActionTypes =
    SetColumnsAction |
    DeletePictureAction |
    MoveDownColumnAction |
    MoveUpColumnAction |
    ResetFiltersAction |
    SetExportTypeAction |
    SetLimitAction |
    SetListAction |
    SetOrderByAction |
    SetPageAction |
    SetRunningAction |
    SetSearchAction |
    ToggleColumnAction |
    ToggleExportAction |
    ToggleExportFullAction |
    ToggleFiltersAction |
    ToggleRefreshAction |
    TogglePicturesOrderAction |
    UpdateFilterCreatedDateGteAction |
    UpdateFilterCreatedDateLteAction |
    UpdateFilterNameAction |
    UpdateFilterCreatorAction |
    UpdateFilterLastAuthorAction |
    UpdateFilterModifiedDateGteAction |
    UpdateFilterModifiedDateLteAction |
    UpdateFilterPeriodAction |
    UpdateFilterPeriodTypeAction |
    UpdatePictureOrderAction |
    ToggleCancelModalAction |
    ToggleCreateAction |
    ToggleUploadIconAction |
    SetCategoryAction |
    SetCategoryDeleteAction |
    ResetAddCategoryAction |
    ResetIcon |
    SetEditStepAction |
    SetIconErrorsAction |
    SetUploadIconVideoInputAction |
    UpdateCircuitCategoryNameLocaleAction |
    UpdateCircuitCategoryDescriptionLocaleAction |
    UpdateIconAction |
    UpdateIconProgressAction |
    UpdateIconStepAction |
    UpdateReference |
    ResizeColumnAction;